<div class="container" *ngIf="!notEnoughEvents">
    <!-- TOP THREE EVENTS SORTED BY totalActiveReservationsCount -->
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Top 1) {{top1Event?.title | truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="this.data_donut_1.length != 0 && !finishedLoadingFlopsAndTops">
                        <ibm-donut-chart [data]="data_donut_1" [options]="config_donut"></ibm-donut-chart>
                        <div *ngIf="finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                    </div>
                    <div *ngIf="this.data_donut_1.length == 0" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Top 2) {{top2Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="this.data_donut_2.length != 0 && !finishedLoadingFlopsAndTops">
                        <ibm-donut-chart [data]="data_donut_2" [options]="config_donut"></ibm-donut-chart>
                        <div *ngIf="finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                    </div>
                    <div *ngIf="this.data_donut_2.length  == 0" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle"> Top 3) {{top3Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="this.data_donut_3.length  != 0 && !finishedLoadingFlopsAndTops">
                        <ibm-donut-chart [data]="data_donut_3" [options]="config_donut"></ibm-donut-chart>
                        <div *ngIf="finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                    </div>
                    <div *ngIf="this.data_donut_3.length  == 0" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <!-- FLOP THREE EVENTS SORTED BY totalActiveReservationsCount -->
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Flop 1) {{flop1Event?.title | truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="this.data_donut_1_flop.length != 0 && !finishedLoadingFlopsAndTops">
                        <ibm-donut-chart [data]="data_donut_1_flop" [options]="config_donut"></ibm-donut-chart>
                        <div *ngIf="finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                    </div>
                    <div *ngIf="this.data_donut_1_flop.length == 0" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Flop 2) {{flop2Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="this.data_donut_2_flop.length  != 0 && !finishedLoadingFlopsAndTops">
                        <ibm-donut-chart [data]="data_donut_2_flop" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div *ngIf="this.data_donut_2_flop.length == 0" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                    <div *ngIf="finishedLoadingFlopsAndTops" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Flop 3) {{flop3Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="this.data_donut_3_flop.length != 0 && !finishedLoadingFlopsAndTops">
                        <ibm-donut-chart [data]="data_donut_3_flop" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div *ngIf="this.data_donut_3_flop.length == 0" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                    <div *ngIf="finishedLoadingFlopsAndTops" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>



    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Kategorienverteilung
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>

                    <ibm-simple-bar-chart *ngIf="this.data_interest.length != 0" [data]="data_interest"
                        [options]="options_line_simple"></ibm-simple-bar-chart>
                    <div *ngIf="this.data_interest.length == 0" class="pieChartEmptyState">
                        Noch keine Kategorienverteilung vorhanden.
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>



    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Preisnachlass
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_savings" [options]="options_line_savings"
                        *ngIf="this.hasEventV1"></ibm-simple-bar-chart>
                    <div *ngIf="!this.hasEventV1" class="pieChartEmptyState">
                        Für diese Informationen bitte Event V2 Mergen
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Aktionstypen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_types" [options]="config_donut_types" *ngIf="this.hasEventV1">
                    </ibm-donut-chart>
                    <div *ngIf="!this.hasEventV1" class="pieChartEmptyState">
                        Für diese Informationen bitte Event V2 Mergen
                    </div>
                </mat-card-content>
            </mat-card>
        </div>


        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Aktioneinschränkungen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_eventLimits" [options]="config_donut_types"
                        *ngIf="this.hasEventV1"></ibm-donut-chart>
                    <div *ngIf="!this.hasEventV2" class="pieChartEmptyState">
                        Für diese Informationen bitte Event V2 Mergen
                    </div>
                </mat-card-content>
            </mat-card>
        </div>


        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Aktionsgutscheincodes
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_voucherStrats" [options]="config_donut_types"
                        *ngIf="this.hasEventV1"></ibm-donut-chart>
                    <div *ngIf="!this.hasEventV2" class="pieChartEmptyState">
                        Für diese Informationen bitte Event V2 Mergen
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        Vergleich aktiver Aktionen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row" [formGroup]="filterTestForm">
                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 1</mat-label>
                                <mat-select formControlName="serachForEvent">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 2</mat-label>
                                <mat-select formControlName="serachForEvent_2">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 3</mat-label>
                                <mat-select formControlName="serachForEvent_3">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="this.filterTestForm.valid">
                        <div class="col-sm-12">
                            <ibm-grouped-bar-chart [data]="data_radar" [options]="options_radar"
                                *ngIf="finishedLoadingComparison"></ibm-grouped-bar-chart>
                            <div *ngIf="!finishedLoadingComparison" class="loadingOverlay">
                                <mat-spinner></mat-spinner>
                            </div>

                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

        </div>
    </div>


    <div class="row" id="calenderRow">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card" [formGroup]="calenderFilterForm">
                <mat-card-header>
                    <mat-card-title>
                        Teilnahmen nach Tagen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field class="full-width">
                        <mat-label>Event auswählen</mat-label>
                        <mat-select formControlName="event" (selectionChange)="changeEventForCalenderChart($event)">
                            <mat-option *ngFor="let sortOption of events" [value]="sortOption.value"
                                [disabled]="sortOption.state">
                                {{sortOption.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div id="calendar_basic" style="width: 100%;min-height: 300px;"></div>
                    <div *ngIf="isCalenderChartEmpty" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                    <div *ngIf="!finishedLoadingCalendeData" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>

            </mat-card>

        </div>
    </div>
</div>

<div class="container" *ngIf="notEnoughEvents">
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Nicht genügend Daten
                    </mat-card-title>
                    <mat-card-subtitle>
                        Um das Reporting nutzen zu können, müssen Sie mindestens eine aktive Aktion einstellen.
                    </mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>
    </div>
</div>